import { Injectable } from '@angular/core';
import { ICategory, ICategoryAPI, ISubCategoryAPI } from './typings';
import { DataContextService } from '../../shared/services/datacontext.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { env } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService extends DataContextService<any> {
  selectedCategory: ICategory | undefined;
  cmSelectedCategory: ICategory | undefined;

  constructor(http: HttpClient) {
    super(http, env.API.get_categories_url);    
  }

  getCategoriesData(): Observable<ICategoryAPI[]> {
    return this.get(env.API.get_categories_url);
  }

  getSubCategoriesData(): Observable<ISubCategoryAPI[]> {
    const urlWithQuery = `${env.API.get_sub_categories_url}?isExternal=false`; // Append the query parameter
    return this.get(urlWithQuery);
  }
}
